'use client';

import { Link } from '@/i18n/navigation';
import { Box, Flex, IconButton, Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useQueryState } from 'nuqs';
import { GoArrowLeft } from 'react-icons/go';
import RestaurantSearch from './_components/top';
import SearchResults from './_components/without-categories';

const BrandSearch = () => {
  const [search] = useQueryState('search', { defaultValue: '' });
  const t = useTranslations();
  return (
    <>
      <Flex w='full' py='3' gap='2' px='4'>
        <Link href='/where-to-go'>
          <IconButton
            aria-label='Back'
            variant='subtle'
            rounded='xl'
            bg='#f5f4f3'
          >
            <GoArrowLeft strokeWidth='0.75' />
          </IconButton>
        </Link>
        <RestaurantSearch />
      </Flex>
      <Flex direction='column' gap='5' p='4'>
        {search ? (
          <SearchResults query={search} />
        ) : (
          <Box>
            <Text fontSize='2xl' fontWeight='bold'>
              {t('what_we_are_looking_for')}
            </Text>
          </Box>
        )}
      </Flex>
    </>
  );
};

export default BrandSearch;
